var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"月次入出金額","icon":"fas fa-signal"}},[_c('base-error-guard',[_c('finance-statement')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }